import { ContentOnlyHeaderTemplate } from './ContentOnlyHeaderTemplate.js';
import { IconOnlyHeaderTemplate } from './IconOnlyHeaderTemplate.js';
import { TooltipHeader } from './TooltipHeader.js';

function getHeaderTemplate(props, panelRef) {
  let template = null;
  if (props.iconOnly) {
    template = IconOnlyHeaderTemplate(props, panelRef);
  }
  if (props.tooltip && template) {
    template = TooltipHeader(Object.assign({
      header: template
    }, props));
  }
  if (props.onlyContent) {
    template = ContentOnlyHeaderTemplate(props, panelRef);
  }
  return template;
}

export { getHeaderTemplate };
